export const MODULE_NAME = 'CrazyWeb';

import * as angular from 'angular';
import 'angular-resource';
import 'angular-ui-router';
import 'angular-permission';

import 'ngstorage';
import 'angular-loading-bar';
import 'angularjs-toaster';
import 'angular-animate';
import 'angular-sanitize';
import 'angular-file-saver';
import 'angular-img-http-src';
import 'angular-strap';
import 'angular-file-upload';
import 'betsol-ng-intl-tel-input';
import 'angular-smart-table';
import 'moment';
import 'angular-moment';
import 'angular-daterangepicker';
import 'angular-timer';
import 'angular-cookies';

import 'angular-translate';
import 'angular-translate-storage-cookie';
import 'angular-translate-storage-local';
import 'angular-translate-loader-static-files';

import 'angularjs-stripe-elements';
import 'angular-load';
import 'ng-tags-input';
import 'ng-focus-if';
import 'ui-select';
import 'angular-touch';
import 'angular-scroll';
import 'ng-infinite-scroll';
import 'checklist-model';
import 'angular-credit-cards';
import 'angularjs-dropdown-multiselect';
import 'angular-stripe';

import 'bootstrap-daterangepicker';
import 'moment/locale/es';

import Config from './config';
import Run from './run';

import Auth from './auth/auth.index';
import Theme from './theme/theme.index';
import Users from './users/users.index';
import Utils from './utils/utils.index';
import Accounts from './accounts/accounts.index';
import Plans from './plans/plans.index';
import Numbers from './numbers/numbers.index';
import Balance from './balance/balance.index';
import Billings from './billings/billings.index';
import { NgXModule } from './ngX/ngXRoutes.index';
import { localStorageSupported } from './utils/localStorageUtils';
import responseNg1 from './api-config-response'

import { environment } from '../../../src/environments/environment';

export const Ng1AppModule = angular
  .injector(['ng'])
  .get('$http')
  .get('/api/config')
  .then(function(res: { data: { [x: string]: any } }) {
    if (!localStorageSupported()) {
      window.location.href = environment.CANNOT_USE_APP_URL;
      return;
    }
    res.data.backend = res.data.backend || environment.BASE_BACKEND_URL;
    res.data.sentryEnabled = res.data.sentryEnabled || environment.SENTRY_ENABLED;
    responseNg1.data = res.data;
    angular
      .module(MODULE_NAME, [
        'ngResource',
        'angular-loading-bar',
        'toaster',
        'ngAnimate',
        'ngSanitize',
        'ngFileSaver',
        'angular.img',
        'mgcrea.ngStrap',
        'angularFileUpload',
        'permission',
        'daterangepicker',
        'betsol.intlTelInput',
        'smart-table',
        'angularMoment',
        'timer',
        'ngStorage',
        'ngCookies',
        'pascalprecht.translate',
        'angularLoad',
        'ngTagsInput',
        'focus-if',
        'ui.select',
        'ngTouch',
        'duScroll',
        'infinite-scroll',
        'checklist-model',
        'credit-cards',
        'angularjs-dropdown-multiselect',
        'angular-stripe',
        'ui.router',
        'angularjs-stripe-elements',
        Users,
        Auth,
        Theme,
        Accounts,
        Utils,
        Plans,
        Billings,
        Numbers,
        Balance,
        NgXModule
      ])
      .run(Run)
      .config(Config)
      .constant('BASE_URL', res.data.backend || environment.BASE_BACKEND_URL)
      .constant('CALL_PANEL_URL', res.data.callPanelUrl || environment.CALL_PANEL_URL)
      .constant('AUTHENTICATION_SERVER', res.data.authentication || environment.SSO_URL)
      .constant('CALL_PANEL_URL2', res.data.callPanelUrl2 || '')
      .constant('WEB_CALL_BACKEND_CONFIGURATOR_URL', environment.WEB_CALL_BACKEND_CONFIGURATOR_URL)
      .constant(
        'API_DOCUMENTATION_URL',
        res.data.apiDocumentationUrl || 'https://developers.channels.app'
      )
      .constant('ASYNC_VALIDATOR_DEBOUNCE', 500)
      .constant('PHOTO_HOST', res.data.photoHost || '//img.crazycall.com/')
      .constant('DASHBOARD_URL', res.data.dashboardUrl || 'https://dashboard.crazycall.com/dev')
      .constant('DATE_TIME_FORMAT', 'yyyy-MM-dd HH:mm:ss')
      .constant('TIME_FORMAT', 'HH:mm:ss')
      .constant('DATE_FORMAT', 'YYYY-MM-DD')
      .constant('weekDays', {
        en: [
          "Mon",
          "Tue",
          "Wed",
          "Thu",
          "Fri",
          "Sat",
          "Sun"
        ],
        es: [
          "Lu",
          "Ma",
          "Mi",
          "Ju",
          "Vi",
          "Sa",
          "Do"
        ]})
      .constant('months', {
        en: [
         'January',
         'February',
         'March',
         'April',
         'May',
         'June',
         'July',
         'August',
         'September',
         'October',
         'November',
         'December'
        ],
        es: [
         'Enero',
         'Febrero',
         'Marzo',
         'Abril',
         'Mayo',
         'Junio',
         'Julio',
         'Agosto',
         'Septiembre',
         'Octubure',
         'Noviembre',
         'Diciembre'
        ]})
      .constant('DATE_TIME_FORMAT_ISO', 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]')
      .constant('LIVE_CHAT_LICENSE', 6849311)
      .constant('WIDGET_ID', res.data.widgetId || 'hmfoachifajaajjebifbjklokdcdbjke')
      .constant(
        'CHROME_STORE_WIDGET',
        `https://chrome.google.com/webstore/detail/${res.data.widgetId ||
          'hmfoachifajaajjebifbjklokdcdbjke'}`
      )
      .constant('SENTRY_ENABLED', res.data.sentryEnabled || false)
      .value('duScrollActiveClass', 'active-link')
      .value('duScrollDuration', 500)
      .value('duScrollOffset', 60);
  });
